<template>
    <v-navigation-drawer v-if="!isMobile" app right permanent width="300" color="surface" class="admin-panel">
        <company-admin-panel-body />
    </v-navigation-drawer>

    <div v-else class="admin-panel--mobile">
        <company-admin-panel-body />
    </div>
</template>

<script>
import CompanyAdminPanelBody from "@/components/company/CompanyAdminPanelBody";

export default {
    name: "CompanyAdminPanel",
    components: { CompanyAdminPanelBody },
}
</script>

<style scoped>
.admin-panel ::v-deep .v-navigation-drawer__border {
    width: 2px !important;
    background-color: var(--v-outline-base) !important;
}

.admin-panel--mobile {
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 14px;
    overflow: hidden;
    margin-top: 24px;
}

.admin-panel--mobile ::v-deep .panel-list {
    max-height: 420px;
}
</style>
